import React from 'react'
import injectSheet from 'react-jss'
import styles from './email.styles'
import Section from '../../../shared/section/section'
import Segment from '../../../shared/segment/segment'
import Segments from '../../../shared/segments/segments'
import Label from '../../../shared/label/label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'
import classNames from 'classnames'
import { Formik } from 'formik'
import * as Yup from 'yup'

const errorMsg = 'This field should not be empty'

const Email = ({ classes, pending, email, onSubmit }) => (
  <Formik
    onSubmit={onSubmit}
    validationSchema={Yup.object().shape({
      email: Yup.string()
        .email('This should be a valid email')
        .required(errorMsg)
    })}
    initialValues={{
      email: email || ''
    }}>
    {formikProps => {
      const {
        values,
        handleBlur,
        handleChange,
        handleSubmit,
        isValid,
        errors
      } = formikProps
      return (
        <form
          onSubmit={handleSubmit}
          className={classNames(classes.form, { [classes.pending]: pending })}>
          <Section
            title="Your email address"
            pending={pending}
            renderHeader={() => (
              <Button
                className={classes.submitButton}
                disabled={!isValid}
                type="submit"
                tall>
                Save changes
              </Button>
            )}>
            <Segments>
              <Segment size={'M'}>
                <Label htmlFor={'email'}>Email</Label>
                <FormInput
                  name="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  placeholder={'Ex: john@myemail.com'}
                  validationError={errors.email}
                />
              </Segment>
            </Segments>
          </Section>
        </form>
      )
    }}
  </Formik>
)

export default injectSheet(styles)(Email)
